module.exports = __webpack_public_path__ + "img/pre.af660d7a.svg";